angular.module('qkr').controller('CommonModalPopupController', ($scope, $uibModalInstance, title, message) => {
    $scope.message = message;
    $scope.title = title;

    $scope.ok = function() {
        $uibModalInstance.close('ok');
    };
    $scope.cancel = function() {
        $uibModalInstance.close('cancel');
    };
});



// WEBPACK FOOTER //
// ./src/controllers/modal/common.popup.controller.js